import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';

export function ListItemLink({ icon: Icon, to, primary }: { icon: any; to: string; primary: string }) {
  return (
    <Link to={to}>
      <ListItem button>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={primary} />
      </ListItem>
    </Link>
  );
}
